import React from 'react';
import MaterialTable from '@material-ui/core/Table';
import '../styles/Table.scss';

const Table = ({children}) => <MaterialTable className="table" size="small">{children}</MaterialTable>;

export default Table;
